var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PromoPageModal',{ref:"promoPageModal",on:{"viewPromoPageClick":_vm.handleViewPromoPageClick}}),_c('PromoPagePreviewModal',{ref:"promoPagePreviewModal",attrs:{"campaign-id":_vm.campaignId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }